import { css } from 'styled-components';

const TextMedium = css`
  line-height: 19px;
  font-size: 16px;
  font-weight: medium;
  letter-spacing: 0.15px;
`;

export default TextMedium;
